import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import '@/assets/css/all.min.css';
import moment from 'moment';
import VueMoment from 'vue-moment';
import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import VueAxios from 'vue-axios';
import router from '../router';
import myPlugin from "./myPlugin";
import gameUtil from "./gameUtility";

// const errorHandler = (error) => {
//     if (error.response != null) {
//         if (error.response.status === 401) {
//             // window.localStorage.removeItem("krule_designer_user");
//             Vue.$ls.remove('access_token');
//             Vue.$ls.remove('user_info');
//             router.replace({ name: 'login' });
//         }
//     }
//     return Promise.reject(error);
// };

// const successHandler = (response) => {
//     return response;
// };

// axios.interceptors.response.use(
//     (response) => successHandler(response),
//     (error) => errorHandler(error),
// );

// axios.interceptors.request.use((config) => {
//     const accToken = Vue.$ls.get('access_token');
//     if (accToken !== null && accToken !== undefined) {
//         config.headers.Authorization = `${accToken}`;
//     }
//     return config;
// }, (err) => {
//     return Promise.reject(err);
// });

// import VueLodash from 'vue-lodash';
// const options = { name: 'lodash' };
// Vue.use(VueLodash, options);

Vue.filter('capitalize', function (value) {
    if (!value) return ''
    value = value.toString()
    return value.charAt(0).toUpperCase() + value.slice(1)
});

Vue.use(VueAxios, axios);
Vue.use(Vuetify);
// Vue.use(require('vue-moment'));
Vue.use(VueMoment, {
    moment,
});

// const videoControls = ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'settings', 'pip', 'airplay', 'fullscreen'];
// const videoControls = ['play-large', 'current-time', 'fullscreen'];

import VuePlyr from 'vue-plyr'
Vue.use(VuePlyr, {
    plyr: {
        //   fullscreen: { enabled: true },
        // controls: videoControls
    },
    emit: ['ended']
});

Vue.use(myPlugin);
Vue.use(gameUtil);

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: 'fa',
    },
});
